import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import moment from 'moment';
import { TbDatabaseExclamation } from 'react-icons/tb';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { Skeleton } from '@mui/material';
import usePermissions from 'hooks/usePermissions';
import StatusBadge from 'ui-component/StatusBadge';
import useIsMobile from 'utils/isMobileUtils';

const DetailsTab = ({
    serialDetails,
    repairLists,
    dataLoaded,
}) => {

    const [allPermissions, hasEveryPermission] = usePermissions();

    const history = useNavigate();
    const isMobile = useIsMobile();
    const handleOpenNewTab = (pageModule, id) => {
            let url = '';
            if (pageModule == 'sales_order') {
                url = `/sales/sales-orders/${id}`;
            } else if (pageModule == 'invoice') {
                url = `/sales/invoices/${id}`;
            } 

            // if (pageModule == 'products') {
            //     url = `/products/${id}`;
            // } else if (pageModule == 'contacts') {
            //     url = `/contacts/${id}`;
            // } else if (pageModule == 'purchase_orders') {
            //     url = `/purchasing/view/${id}`;
            // } else if (pageModule == 'sales_orders') {
            //     url = `/sales/sales-orders/${id}`;
            // } else if (pageModule == 'invoices') {
            //     url = `/sales/invoices/${id}`;
            // } else if (pageModule == 'quotations') {
            //     url = `/sales/quotations/${id}`;
            // }
            if (url) {
                history(url);
                // window.open(url, '_blank');
            }
        };
    if (isMobile) {
        return (
            <div className="row">
                {/* General Info Card */}
                <div className="col-12 form-group">
                    <div className="card p-2">
                        <div className="product-card minHeight230 pad10-25">
                        
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Product</label>
                                    <span className="fw600">{serialDetails?.product?.name ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>SKU</label>
                                    <span className="fw600">{serialDetails?.product?.sku ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Category</label>
                                    <span className="fw600">{serialDetails?.product?.category ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Storage</label>
                                    <span className="fw600">{serialDetails?.storage ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Grade</label>
                                    <span className="fw600">{serialDetails?.grade ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>IMEI</label>
                                    <span className="fw600">{serialDetails?.imei ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Status</label>
                                    <span className="fw600">{serialDetails?.status ?? '-----'}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                    <label style={{margin: 0}}>Color</label>
                                    <span className="fw600">{serialDetails?.color?.name ?? '-----'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Order Details Card */}
                {serialDetails?.transactions?.length > 0 && (
                    <div className="col-12 form-group">
                        <div className="card p-2">
                            <div className="product-card minHeight230 pad10-25">
                                <div className="form-section">
                                    <div className="product-section-head font18">
                                        <b>Order Details</b>
                                    </div>
                                </div>
                                {serialDetails?.transactions?.map((row, idx) => (
                                    <div key={idx} style={{ borderBottom: '1px solid #eee', paddingBottom: 10, marginBottom: 10 }}>
                                        <div className="row">
                                            <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                                <label style={{margin: 0}}>Sales Order</label>
                                                <span
                                                    className={`fw600 ${hasEveryPermission(['View Sales Orders Details']) ? 'text-primary cursor-pointer' : ''}`}
                                                    onClick={() => {
                                                        if (hasEveryPermission(['View Sales Orders Details'])) {
                                                            history(`/sales/sales-orders/${row?.sales_order?.id}`);
                                                        }
                                                    }}
                                                >
                                                    {row?.sales_order?.sales_order_number ?? '-----'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                                <label style={{margin: 0}}>Invoice</label>
                                                <span
                                                    className={`fw600 ${hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                                    onClick={() => {
                                                        if (hasEveryPermission(['View Estimation Details (Page)'])) {
                                                            history(`/sales/invoices/${row?.invoice?.id}`);
                                                        }
                                                    }}
                                                >
                                                    {row?.invoice?.invoice_number ?? '-----'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                                <label style={{margin: 0}}>Customer</label>
                                                <span className="fw600">{row?.customer?.name ?? '-----'}</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                                <label style={{margin: 0}}>Shipped</label>
                                                <span className="fw600">
                                                    {row?.shipped_date ? moment(row?.shipped_date).format(CommonDateOnlyFormat) : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="justify-content-between col-12" style={{ display: 'flex' }}>
                                                <label style={{margin: 0}}>Inbound</label>
                                                <span className="fw600">
                                                    {serialDetails?.inbound_date ? moment(serialDetails?.inbound_date).format(CommonDateOnlyFormat) : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <>
            <div className="content mt15">


                <div className="row align-items-top">
                    <div className="col-12 form-group" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                        <div className="textGray serial-details-basic-info-container" style={{ width: '100px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        Product
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ maxWidth: '275px', marginLeft: '10px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        { serialDetails?.product?.name ?? '-----' }
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'200px'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="row align-items-top">
                    <div className="col-md-4 col-12 form-group" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                        <div className="textGray serial-details-basic-info-container" style={{ width: '100px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        SKU
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ maxWidth: '275px', marginLeft: '10px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        { serialDetails?.product?.sku ?? '-----' }
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'200px'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="row align-items-top">
                    <div className="col-md-4 col-12 form-group" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                        <div className="textGray serial-details-basic-info-container" style={{ width: '100px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        Category
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ maxWidth: '275px', marginLeft: '10px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        { serialDetails?.product?.category ?? '-----' }
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'200px'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="row align-items-top">
                    <div className="col-md-4 col-12 form-group" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                        <div className="textGray serial-details-basic-info-container" style={{ width: '100px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        Storage
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ maxWidth: '275px', marginLeft: '10px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        { serialDetails?.storage ?? '-----' }
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'200px'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className="row align-items-top">
                    <div className="col-md-4 col-12 form-group" style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }} >
                        <div className="textGray serial-details-basic-info-container" style={{ width: '100px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        Grade
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                        <div style={{ maxWidth: '275px', marginLeft: '10px' }}>
                            {
                                dataLoaded ? ( 
                                    <>
                                        { serialDetails?.grade ?? '-----' }
                                    </>
                                ) : (
                                    <>
                                        <Skeleton variant="rounded" width={'200px'} height={20}></Skeleton>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>

                {
                    serialDetails?.transactions?.length > 0 && (
                        <>
                            <div style={{ padding: '10px 0px 20px 0px' }}>
                    
                                <div className="row mb10">
                                    <div className="col-12">
                                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Order Details</h2>
                                    </div>
                                </div>

                                <div className="dynamic-listing">
                                    <div className="dynamic-listing-header">
                                        <div className="row">
                                            <div className="col-md-2 font600">Sales Order</div>
                                            <div className="col-md-2 font600">Invoice</div>
                                            <div className="col-md-3 font600">Customer</div>
                                            <div className="col-md-3 font600">Date</div>
                                            <div className="col-md-2 font600">Warranty</div>
                                        </div>
                                    </div>
                                    <hr className="mt8 mb8" />

                                    {
                                        serialDetails?.transactions?.map((row, index) => (
                                            <>

                                                <div className="row">
                                                    <div className="col-md-2 d-flex align-items-center">
                                                        <div className="d-flex gap-4">

                                                            <div className="dynamic-listing-label-container" style={{ marginRight: '10px' }}>
                                                                <label className="dynamic-listing-label textGray">Sales Order</label> 
                                                            </div>
                                                            <div
                                                                className={`${hasEveryPermission(['View Sales Orders Details']) ? 'text-primary cursor-pointer' : '' }`}
                                                                onClick={() => {
                                                                    if (hasEveryPermission(['View Sales Orders Details'])) {
                                                                        handleOpenNewTab('sales_order', row?.sales_order?.id)
                                                                    }
                                                                }}
                                                            >
                                                                {row?.sales_order?.sales_order_number}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 d-flex align-items-center">
                                                        <div className="d-flex gap-4">
                                                            <div className="dynamic-listing-label-container" style={{ marginRight: '38px' }}>
                                                                <label className="dynamic-listing-label textGray">Invoice</label> 
                                                            </div>
                                                            <div
                                                                className={`${hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : '' }`}
                                                                onClick={() => {
                                                                    if (hasEveryPermission(['View Estimation Details (Page)'])) {
                                                                        handleOpenNewTab('invoice', row?.invoice?.id)
                                                                    }
                                                                }}
                                                            >
                                                                {row?.invoice?.invoice_number}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 d-flex align-items-center">
                                                        <div className="d-flex gap-4">
                                                            <div className="dynamic-listing-label-container" style={{ marginRight: '20px' }}>
                                                                <label className="dynamic-listing-label textGray">Customer</label> 
                                                            </div>
                                                            <div
                                                                className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : '' }`}
                                                                onClick={() => {
                                                                    if (hasEveryPermission(['View Contact Details (Page)'])) {
                                                                        handleOpenNewTab('contacts', row?.customer?.id)
                                                                    }
                                                                }}
                                                            >
                                                                {row?.customer?.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 ">
                                                        <div className="dynamic-listing-two-rows-horizontal-view">

                                                            <div className="d-flex justify-left items-center gap-4 text-12">
                                                                <div className="textGray ">Shipped</div>
                                                                <div className="font600">
                                                                    {
                                                                        row?.shipped_date ? (
                                                                            <>
                                                                                {moment(row?.shipped_date).format(CommonDateOnlyFormat)}
                                                                            </>
                                                                        ) : (
                                                                            <>N/A</>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-left items-center gap-4 text-12">
                                                                <div className="textGray ">Inbound</div>
                                                                <div className="font600">
                                                                    {
                                                                        serialDetails?.inbound_date ? (
                                                                            <>
                                                                                {moment(serialDetails?.inbound_date).format(CommonDateOnlyFormat)}
                                                                            </>
                                                                        ) : (
                                                                            <>N/A</>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="dynamic-listing-two-rows-vertical-view">
                                                            <div className="row">

                                                                <div className="col-md-12 d-flex align-items-center">
                                                                    <div className="d-flex gap-4">
                                                                        <div className="dynamic-listing-label-container" style={{ marginRight: '31px' }}>
                                                                            <label className="dynamic-listing-label textGray">Shipped</label> 
                                                                        </div>
                                                                        <div>
                                                                            {
                                                                                row?.shipped_date ? (
                                                                                    <>
                                                                                        {moment(row?.shipped_date).format(CommonDateOnlyFormat)}
                                                                                    </>
                                                                                ) : (
                                                                                    <>N/A</>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 d-flex align-items-center">
                                                                    <div className="d-flex gap-4">
                                                                        <div className="dynamic-listing-label-container" style={{ marginRight: '14px' }}>
                                                                            <label className="dynamic-listing-label textGray">Inbounded</label> 
                                                                        </div>
                                                                        <div>
                                                                            {
                                                                                serialDetails?.inbound_date ? (
                                                                                    <>
                                                                                        {moment(serialDetails?.inbound_date).format(CommonDateOnlyFormat)}
                                                                                    </>
                                                                                ) : (
                                                                                    <>N/A</>
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 d-flex">
                                                        <div className="d-flex gap-4">
                                                            <div className="dynamic-listing-label-container" style={{ marginRight: '25px' }}>
                                                                <label className="dynamic-listing-label textGray">Warranty</label> 
                                                            </div>
                                                            <div className="d-flex justify-left items-center" style={{ width: '110px'}}>
                                                                {
                                                                    row?.warranty === 'Expired' ? (
                                                                        <>
                                                                            <StatusBadge itemStatus={'Expired'} />
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {row?.warranty}
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="mt8 mb8" />
                                            </>
                                        ))
                                    }
                                </div>
                            </div>
                        </>
                    )
                }   

                

            </div>
        </>
    );
};

export default DetailsTab;
